var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultipleReportCardView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 573,
    height: 458,
    "aria-labelledby": titleId,
    viewBox: "0 0 573 458",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loading-aria"
  }, "Loading...") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loading-aria"
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    clipPath: "url(#clip-path)",
    style: {
      fill: "url(\"#fill\")"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    rx: 0,
    ry: 0,
    width: "NaN",
    height: "NaN"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 107,
    rx: 3,
    ry: 3,
    width: 110,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 133,
    rx: 3,
    ry: 3,
    width: 178,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 157,
    rx: 3,
    ry: 3,
    width: 110,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 184,
    rx: 15,
    ry: 15,
    width: 138,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 183,
    rx: 15,
    ry: 15,
    width: 66,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 184,
    rx: 15,
    ry: 15,
    width: 63,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 221,
    rx: 3,
    ry: 3,
    width: 110,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 247,
    rx: 15,
    ry: 15,
    width: 138,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 246,
    rx: 15,
    ry: 15,
    width: 66,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 247,
    rx: 15,
    ry: 15,
    width: 94,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 247,
    rx: 15,
    ry: 15,
    width: 63,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    rx: 0,
    ry: 0,
    width: 92,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 23,
    rx: 0,
    ry: 0,
    width: 110,
    height: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 555,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 58,
    rx: 15,
    ry: 15,
    width: 100,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 57,
    rx: 15,
    ry: 15,
    width: 120,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 56,
    rx: 15,
    ry: 15,
    width: 145,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 285,
    rx: 3,
    ry: 3,
    width: 110,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 311,
    rx: 15,
    ry: 15,
    width: 138,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 310,
    rx: 15,
    ry: 15,
    width: 66,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 311,
    rx: 15,
    ry: 15,
    width: 94,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 311,
    rx: 15,
    ry: 15,
    width: 63,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 348,
    rx: 0,
    ry: 0,
    width: 92,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 378,
    rx: 15,
    ry: 15,
    width: 100,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 376,
    rx: 15,
    ry: 15,
    width: 120,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 374,
    rx: 15,
    ry: 15,
    width: 145,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 424,
    rx: 10,
    ry: 10,
    width: 85,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 424,
    rx: 10,
    ry: 10,
    width: 85,
    height: 24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.599964,
    stopColor: "#f3f3f3",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-2; -2; 1",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 1.59996,
    stopColor: "#ecebeb",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-1; -1; 2",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 2.59996,
    stopColor: "#f3f3f3",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0; 0; 3",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleReportCardView);
export default __webpack_public_path__ + "static/media/multiple_report_card_view.20453ff4eb5ccca4a1e0530a85995436.svg";
export { ForwardRef as ReactComponent };